<div class="search-wrapper">
  <div class="search-inner-wrapper  thin-scroll">
    <div class="section search-section">
      <h3>{{ 'archive:Log for External access given' | i18next }}</h3>
      <div class="section-content">
        <div class="section-content-row" >
          <div class="date-picker">
            <app-date-picker (setPeriod)="setPeriod($event)" [showTitle]="true" [(data)]="selectedData"
              [dataAvailableFor]="0"></app-date-picker>
          </div>
          <div class="btn-search-container">
            <button (click)="Search()" mat-flat-button [ngClass]="['primary-button', 'btn-search']"
              style="align-self: flex-end;">{{'archive:Search' | i18next}}</button>
          </div>
          <div >
            <span style="display: inline-block;  margin-bottom: 5px;">{{ 'archive:Type' | i18next }}</span><ng-select #ngSelectControl [items]="archiveTypes"
              [(ngModel)]="searchModel.type" [searchable]="false" bindLabel="name" bindValue="id"
              dropdownPosition="bottom"></ng-select>
          </div>
          <div >
            <app-textbox [(model)]="searchModel.username" textboxWidth="100%" [title]="'archive:Ordered by' | i18next "></app-textbox>
          </div>
        </div>
<div class="section-content-row">
          <div style="flex-grow: 10; ">
          <app-textbox [(model)]="searchModel.recipientName" textboxWidth="100%" [title]="'archive:Recipient\'s name' | i18next "></app-textbox>
        </div>
        <div style="flex-grow: 10; margin-left: 10px;">
          <app-textbox [(model)]="searchModel.recipientEmail" textboxWidth="100%" [title]="'archive:Recipient\'s email' | i18next "></app-textbox>
        </div>
</div>


      </div>
    </div>

    <div class="result-section section" *ngIf="dataLoaded">
      <h3>{{ 'archive:Search result' | i18next }}</h3>
      <div class="section-content  thin-scroll">
        <ng-container *ngIf="logs?.length">
          <table>
            <thead>
              <tr>
                <th style="min-width: 130px;" (click)="sortLogs('date')"
                  [matTooltip]="'When the Puzzel user sent the link to the recording(s) to the recipient'"
                  matTooltipClass="tooltip-font-14">
                  {{ 'archive:Date and time' | i18next }} <app-sort-indicator [property]="'date'"
                    [sort]="logSort"></app-sort-indicator>
                </th>
                <th (click)="sortLogs('username')">{{ 'archive:Ordered by' | i18next }} <app-sort-indicator
                    [property]="'username'" [sort]="logSort"></app-sort-indicator></th>
                <th (click)="sortLogs('recipientName')">{{ 'archive:Recipient\'s name' | i18next }} <app-sort-indicator
                    [property]="'recipientName'" [sort]="logSort"></app-sort-indicator></th>
                <th (click)="sortLogs('recipientEmail')">{{ 'archive:Recipient\'s email' | i18next }}
                  <app-sort-indicator [property]="'recipientEmail'" [sort]="logSort"></app-sort-indicator></th>
                <th (click)="sortLogs('reason')">{{ 'archive:Reason' | i18next }} <app-sort-indicator
                    [property]="'reason'" [sort]="logSort"></app-sort-indicator></th>
                <th (click)="sortLogs('messageSent')">{{ 'archive:Message sent' | i18next }} <app-sort-indicator
                    [property]="'messageSent'" [sort]="logSort"></app-sort-indicator></th>
                <th (click)="sortLogs('timeToLive')"
                  [matTooltip]="'The number of days the recording(s) will be available on the link sent'"
                  matTooltipClass="tooltip-font-14">
                  {{ 'archive:Days access' | i18next }} <app-sort-indicator [property]="'timeToLive'"
                    [sort]="logSort"></app-sort-indicator>
                </th>
                <th (click)="sortLogs('language')">{{ 'archive:Language' | i18next }} <app-sort-indicator
                    [property]="'language'" [sort]="logSort"></app-sort-indicator></th>
                <th (click)="sortLogs('recordings')">{{ 'archive:Call recording(s)' | i18next }} <app-sort-indicator
                    [property]="'recordings'" [sort]="logSort"></app-sort-indicator></th>
                <th (click)="sortLogs('requestSource')">{{ 'archive:Caller\'s number' | i18next }} <app-sort-indicator
                    [property]="'requestSource'" [sort]="logSort"></app-sort-indicator></th>
              <th  (click)="sortLogs('allowDownload')">
                <i class="far fa-file-download ico-allow-download" [matTooltip]="'archive:Allow recipient to download' | i18next" matTooltipClass="tooltip-font-14"></i>
                    <app-sort-indicator [property]="'allowDownload'" [sort]="logSort"></app-sort-indicator>
              </th>
                <th (click)="sortLogs('status')"
                  [matTooltip]="'Shows ‘Valid’ if the access has not yet expired, otherwise ‘expired’. If you need to remove the access given before the access has expired after x days, you can click Cancel and confirm in the modal appearing'"
                  matTooltipClass="tooltip-font-14">
                  {{ 'archive:Status' | i18next }} <app-sort-indicator [property]="'status'"
                    [sort]="logSort"></app-sort-indicator>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let log of logs; track log">
                <td>{{log.date + 'Z'| date : "dd-MM-yyyy HH:mm" }}</td>
                <td>{{ log.username }}</td>
                <td>{{ log.recipientName }}</td>
                <td>{{ log.recipientEmail }}</td>
                <td class="wrap td-reason">{{ log.reason }}</td>
                <td matTooltipClass="tooltip-font-14" [tooltip]="log.messageSent">
                  <ng-container *ngIf="log.messageSent.replaceAll('<br/>',' ') as msg">
                    {{ (msg.length > 20) ? msg.slice(0, 20) + '&hellip;' : msg }}
                  </ng-container>
                </td>
                <td>{{ log.timeToLive }}</td>
                <td>{{ log.language }}</td>
                <td>
                  <ng-container *ngFor="let record of log.recordings">
                    <div><a href="{{baseUrl}}/ArchiveSearch/Index/?sessionId={{record.sessionId}}" target="_blank">{{
                        record.callId ?? record.sessionId }}</a> </div>
                  </ng-container>
                </td>
                <td>
                  <ng-container *ngFor="let source of log.requestSource ">
                    <div> {{ source }}</div>
                  </ng-container>
                </td>
                 <td>
                  <ng-container *ngIf="log.allowDownload">
                    {{ 'Yes' | i18next }}
                  </ng-container>
                </td>
                <td [ngSwitch]="log.status">
                  <span *ngSwitchCase="statusType.Valid"><b>{{ 'archive:Valid' | i18next }}</b> / <a
                      href="javascript:void(0)" (click)="cancelEXtShare(log.id,log.recipientEmail,log.recordings)">{{
                      'archive:Click to cancel' | i18next }}</a></span>
                  <span *ngSwitchCase="statusType.Cancelled">{{ 'archive:Cancelled by' | i18next }} {{log.cancelledBy}}
                    {{
                    'archive:on' |
                    i18next }} {{ log.cancelledDate + 'Z'|date:"dd-MM-yyyy HH:mm" }}</span>
                  <span *ngSwitchCase="statusType.Expired">{{ 'archive:Access has expired' | i18next }} </span>
                </td>
              </tr>
          </table>
        </ng-container>
        <ng-container *ngIf="!logs?.length">
          <div class="no-result">{{ 'dashboard:Sorry, we couldn\'t find any results.' | i18next }}</div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
